import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './grid-form-textarea.css'

const GridFormTextarea = ({ field, placeholder, rows = 4 }) => (
  <textarea placeholder={placeholder} styleName="textarea" rows={rows} {...field}></textarea>
)

GridFormTextarea.propTypes = {
  field: PropTypes.object,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
}

export default CSSModules(GridFormTextarea, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-textarea/grid-form-textarea.js
 **/